import api from "./api";

export const salesReportService = {

  // 📅 Date wise sales
  getByDate: async (date) => {
    try {
      const res = await api.get(`/find-sold-bike-details/${date}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  // 📊 Weekly sales
  getWeekly: async (year) => {
    try {
      const res = await api.get(`/find-sold-bike-weekly-details/${year}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  // 📈 Monthly sales
  getMonthly: async (year, month) => {
    try {
      const res = await api.get(`/find-sold-bike-monthly-details/${year}/${month}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

};